import { render, staticRenderFns } from "./VehicleDetailsForm.vue?vue&type=template&id=a420ac74&"
import script from "./VehicleDetailsForm.vue?vue&type=script&lang=js&"
export * from "./VehicleDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports